import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { adjustStringLength } from '@utils/navigationHelpers';
import { displayNameLimits } from '@data/navigation';
import Dropdown from './Dropdown';
import NavigationLinkItem from './NavigationLinkItem';

const DropNavigationItem = ({
  name,
  links,
  dropClassName,
  toggleClassName,
  menuClassName,
  isMobileNav,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((prevState) => !prevState);
  return (
    <Dropdown toggle={toggle} isOpen={isOpen} className={dropClassName} inNavbar nav>
      <DropdownToggle nav caret className={toggleClassName}>
        {
        isMobileNav
          ? name
          : adjustStringLength(name, displayNameLimits.headerDropdownTitle)
        }
      </DropdownToggle>
      <DropdownMenu className={menuClassName}>
        {Array.isArray(links)
        && links.map((link) => (
          <NavigationLinkItem
            fullName={link.title}
            href={link.link}
            key={`${link.title}`}
            name={
              isMobileNav
                ? link.title
                : adjustStringLength(link.title, displayNameLimits.headerLinkName)
              }
            source={link.source}
            type="dynamic"
          />
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

DropNavigationItem.defaultProps = {
  dropClassName: '',
  menuClassName: '',
  toggleClassName: '',
  isMobileNav: false,
};

const linkType = PropTypes.shape({
  source: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
});

DropNavigationItem.propTypes = {
  dropClassName: PropTypes.string,
  links: PropTypes.arrayOf(linkType).isRequired,
  name: PropTypes.string.isRequired,
  menuClassName: PropTypes.string,
  toggleClassName: PropTypes.string,
  isMobileNav: PropTypes.bool,
};

export default DropNavigationItem;
